import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext";
import { resolvePostLoginRedirect } from "utils/postLoginRedirect";

const useLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    remember: false,
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleFieldChange = (e) => {
    const { name, value, checked, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = formData;

    setIsLoading(true);
    try {
      const result = await login(email, password);

      if (result.success) {
        const userData = result.data || {};
        const displayName = userData.username || userData.email || "User";
        toast.success(`Welcome back, ${displayName}!`, { theme: "colored" });
        // navigate('/'); // Navigate to root dashboard

        const redirectTo = resolvePostLoginRedirect(location, "/");
        navigate(redirectTo, { replace: true });
      } else {
        toast.error(`Login failed: ${result.error}`, { theme: "colored" });
      }
    } catch (error) {
      toast.error(`Login failed: ${error.message}`, { theme: "colored" });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    formData,
    handleFieldChange,
    handleSubmit,
    isLoading,
  };
};

export default useLogin;
